export class LeaveDetailModel {
    constructor(
        public LeaveId?: number,
        public Tipo?: string,
        public TipoChar?: string,
        public FBaja?: string,
        public FAlta?: string,
        public Recaida?: string,
        public AvisoBaja?: string,
        public DateDiffBaja?: number,
        public BajaDia?: string,
        public AvisoAlta?: string,
        public DateDiffAlta?: number,
        public AltaDia?: string,
        public Dias?: number,
        public Fpa?: string,
        public DateDiffFpa?: number,
        public FpaDia?: string,
        public CodDiagnostico?: string,
        public leaveRef?: string,
        public Diagnostico?: string,
        public RiesgosPsicosociales?: string,
        public Justificada?: string,
        public Cronico?: string,
        public Agudo?: string,
        public Actitud?: string,
        public Cirujia?: string,
        public Embarazada?: string,
        public FCierre?: string,
        public Marcas?: string,
        public NoVisitar?: string,
        public Prioritaria?: string
    ) {}
}
